import { useVisibilityConfig } from '../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';

/**
 * Gates the "Add to Reports" affordance (Ask AICA card/menu + sheet/docx drawer buttons, Data Room three-dots)
 * behind the shared visibility config. Shown ONLY when `reports.addToReports` is explicitly `1` (WRITE) for the PNO.
 * Absent or any non-1 value (fail-open READ `0`, or HIDDEN `-1`) → hidden — so it stays off by default and never
 * flashes visible while the config is still loading. `canWrite` (level === WRITE) enforces exactly that.
 */
export const useAddToReportsVisible = () => useVisibilityConfig().canWrite(VISIBILITY_KEYS.REPORTS.ADD_TO_REPORTS);
